"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailPage = void 0;
require("../../css/product-detail-page.scss");
require("../../css/miele-description-style.scss");
var GenericFunctions = require("../generic-functions");
var bookmarked_products_page_1 = require("./bookmarked-products-page");
var api_constants_1 = require("../constants/api-constants");
var constants_1 = require("../constants/constants");
require('imports-loader!../vendors/elevatezoom/jquery.elevateZoom-3.0.8.min.js');
require("jquery-form");
require("jquery-validation");
require('imports-loader!../vendors/messages_de.js');
var IframeComms = require("../frame-comms/iframe-comms");
var ProductDetailPage = /** @class */ (function () {
    function ProductDetailPage() {
    }
    ProductDetailPage.init = function (memberNr, productId, ServerContentLoaded) {
        //show the view
        $("#product-detail-page").show();
        if (!ServerContentLoaded) {
            ProductDetailPage.loadData(memberNr, productId);
        }
        else {
            ProductDetailPage.initComponents(memberNr, productId);
        }
        //parent scroll: markenkliq catalog usually is inserted as an iframe inside a parent app.
        //scroll info needed for show the floating menu
        window.addEventListener('message', function (e) {
            var scrollPosition = Math.abs(e.data);
            ProductDetailPage.toggleFixedMenu(scrollPosition);
        }, false);
    };
    ProductDetailPage.loadData = function (memberNr, productId) {
        $("#product-detail-container").html("");
        GenericFunctions.addLoadingIcon("#product-detail-container");
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.ProductDetail + "/" + productId
        });
        promise.done(function (data) {
            var callBack = function () {
                GenericFunctions.removeLoadingIcon("#product-detail-container");
                $("#product-detail-container").html(data);
                ProductDetailPage.initComponents(memberNr, productId);
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            GenericFunctions.showErrorMessage(constants_1.Constants.ErrorGettingProductDetail);
        });
        promise.always(function () {
            GenericFunctions.removeLoadingIcon("#product-detail-container");
            IframeComms.propagateHeight(false);
        });
    };
    ProductDetailPage.buildSearchPageUrl = function () {
        var mainCategoryId = $("#product-main-category-id").text();
        var categoryId = $("#product-category-id").text();
        var subcategoryFilter = "";
        if (categoryId != null) {
            subcategoryFilter = "/?SubCategoryId=" + categoryId;
        }
        return window.BaseUrlWithVersions + "/ProductSearch/" + mainCategoryId + subcategoryFilter;
    };
    ProductDetailPage.initComponents = function (memberNr, productId) {
        //If the product does not exists we reload to other page
        if ($("#product-detail-container").children().length == 0) {
            var appCallback = function () {
                if (History.getStateByIndex(History.savedStates.length - 2).title.indexOf("BookMarkedProducts") != -1) {
                    History.back();
                    $("#product-deleted-modal #delete-product-modal-button").attr("product-id", productId);
                }
                else if (History.getStateByIndex(History.savedStates.length - 2).title.indexOf("ProductSearch") != -1) {
                    History.back();
                }
                else {
                    var url = window.BaseUrlWithVersions;
                    History.pushState({}, url, url);
                }
                $("#generic-info-modal #info-text").text(constants_1.Constants.ProductDoesNotExistsHomePage);
                $("#generic-info-modal").modal("show");
            };
            var firstNavigationCallback = function () {
                var url = window.BaseUrlWithVersions;
                History.pushState({}, url, url);
                $("#generic-info-modal #info-text").text(constants_1.Constants.ProductDoesNotExistsHomePage);
                $("#generic-info-modal").modal("show");
            };
            GenericFunctions.redirectCallbacks(firstNavigationCallback, appCallback);
            return;
        }
        //show the view
        $("#product-detail-page").show();
        //events
        $("#mark-product-button, #mark-product-button-header-menu").off("click");
        $("#mark-product-button, #mark-product-button-header-menu").on("click", function (e) {
            if ($(this).hasClass("selected")) {
                bookmarked_products_page_1.BookMarkedProducts.loadAndRemoveMarkedProductFromLocalStorage(memberNr, productId);
                $("#mark-product-button, #mark-product-button-header-menu").removeClass("selected");
            }
            else {
                bookmarked_products_page_1.BookMarkedProducts.addMarkedProductToLocalStorage(memberNr, productId);
                $("#mark-product-button, #mark-product-button-header-menu").addClass("selected");
            }
        });
        $("#ask-product-button-header-menu").off("click");
        $("#ask-product-button-header-menu").on("click", function () {
            $("#fixed-product-header-menu").css("visibility", "hidden");
            $("#product-detail-page").scrollTop(0);
            ProductDetailPage.showContactForm();
        });
        $("#ask-product-button").off("click");
        $("#ask-product-button").on("click", function () {
            ProductDetailPage.showContactForm();
        });
        $("#product-detail-page .navigation-icons .back-button").off("click");
        var appCallback = function () {
            $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                History.back();
            });
        };
        var firstNavigationCallback = function () {
            $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                var url = ProductDetailPage.buildSearchPageUrl();
                History.pushState({}, url, url);
            });
        };
        GenericFunctions.redirectCallbacks(firstNavigationCallback, appCallback);
        //styles
        $("#mark-product-button, #mark-product-button-header-menu").removeClass("selected");
        if (bookmarked_products_page_1.BookMarkedProducts.isMarkedProduct(memberNr, productId)) {
            $("#mark-product-button, #mark-product-button-header-menu").addClass("selected");
        }
        //zoom
        if ($("#product-detail-gallery a").length > 0) {
            $("#product-detail-gallery .carousel-control-prev.left").off("click");
            $("#product-detail-gallery .carousel-control-next.right").off("click");
            $("#product-detail-gallery .carousel-control-prev.left").on("click", function () {
                if ($("#product-detail-gallery a.hiddenLeftImage").length > 0) {
                    $("#product-detail-gallery a.hiddenLeftImage").last().removeClass("hiddenLeftImage");
                    $("#product-detail-gallery a:not(.hiddenRightImage)").last().addClass("hiddenRightImage");
                }
                ProductDetailPage.checkNavigation();
            });
            $("#product-detail-gallery .carousel-control-next.right").on("click", function () {
                if ($("#product-detail-gallery a.hiddenRightImage").length > 0) {
                    $("#product-detail-gallery a.hiddenRightImage").first().removeClass("hiddenRightImage");
                    $("#product-detail-gallery a:not(.hiddenLeftImage)").first().addClass("hiddenLeftImage");
                }
                ProductDetailPage.checkNavigation();
            });
            $(".gallery-item").off("click.setResource");
            $(".gallery-item").on("click.setResource", function () {
                ProductDetailPage.setResourceCointainer($(this));
            });
            //select the first item
            var firstItem = $("#product-detail-gallery a").first();
            firstItem.addClass("active");
            ProductDetailPage.initGalleryResizeEvents();
            ProductDetailPage.setResourceCointainer(firstItem);
            //resize
            $(window).off();
            $(window).on("resize", function () {
                clearTimeout(ProductDetailPage.timeoutResize);
                ProductDetailPage.timeoutResize = setTimeout(function () {
                    ProductDetailPage.initGalleryResizeEvents();
                }, 300);
            });
        }
        //contact form
        var $contactFormProductDetail = $("#contact-form-product-detail");
        if ($contactFormProductDetail.html().length == 0) {
            $contactFormProductDetail.html($("#contact-form-container").html());
        }
        $("#contact-form-product-detail #send-contact-form-button").off("click");
        $("#contact-form-product-detail #send-contact-form-button").on("click", function () {
            var $productForm = $("#product-inquiry-form");
            if ($productForm.valid()) {
                $productForm.ajaxSubmit({
                    success: function (resp) {
                        $("#generic-info-modal #info-text").text(constants_1.Constants.CorrectSentContactForm);
                        $("#generic-info-modal").modal("show");
                        ProductDetailPage.hideContactForm();
                    },
                    error: function (resp) {
                        $("#generic-error-modal #error-text").text(constants_1.Constants.ErrorSendContactForm);
                        $("#generic-error-modal").modal("show");
                    }
                });
            }
        });
        $("#contact-form-product-detail #cancel-contact-form-button").off("click");
        $("#contact-form-product-detail #cancel-contact-form-button").on("click", function () {
            ProductDetailPage.hideContactForm();
        });
        //Floating menu
        $(document).off("scroll");
        $(document).on("scroll", function () {
            ProductDetailPage.toggleFixedMenu($(this).scrollTop(), true);
        });
        //scape key contact form
        var KEYCODE_ESC = 27;
        $(document).off("keyup.contactForm");
        $(document).on("keyup.contactForm", function (e) {
            if (e.keyCode == KEYCODE_ESC) {
                if ($("#contact-form-product-detail").css("visibility") == "visible") {
                    ProductDetailPage.hideContactForm();
                }
            }
        });
        $("#contact-form-type-select").off("change");
        $("#contact-form-type-select").on("change", function () {
            var type = $(this)[0].value;
            $("#contact-form-email").hide();
            $("#contact-form-tel").hide();
            $("#contact-form-address").hide();
            if (type == 0 /* server.TypesId.Mail */)
                $("#contact-form-email").show();
            else if (type == 1 /* server.TypesId.Phone */)
                $("#contact-form-tel").show();
            else if (type == 2 /* server.TypesId.Address */)
                $("#contact-form-address").show();
        });
    };
    ProductDetailPage.checkNavigation = function () {
        $("#product-detail-gallery a.hiddenLeftImage").length == 0 ? $("#product-detail-gallery .carousel-control-prev.left").addClass("disabled") : $("#product-detail-gallery .carousel-control-prev.left").removeClass("disabled");
        $("#product-detail-gallery a.hiddenRightImage").length == 0 ? $("#product-detail-gallery .carousel-control-next.right").addClass("disabled") : $("#product-detail-gallery .carousel-control-next.right").removeClass("disabled");
    };
    ProductDetailPage.setResourceCointainer = function ($el) {
        if ($el.hasClass("product-video")) {
            $("#product-video").html($el.find(".product-video-content").html());
            $("#zoom-image-container").hide();
            $("#product-video").show();
            if (!GenericFunctions.isMobile()) {
                $('body').addClass("show-zoom");
            }
        }
        else if ($el.hasClass("product-image")) {
            $("#product-video").hide();
            $("#zoom-image-container").show();
            //only show the zoom if the image is bigger
            $('body').removeClass("show-zoom");
            $('<img src="' + $el.data("image") + '">').load($el.data("image"), function () {
                var image = $(this).get()[0];
                if (image != undefined) {
                    var width = image.width;
                    var height = image.height;
                    if ($el.data("zoom-height-threshold") > height || $el.data("zoom-width-threshold") > width) {
                        if (!GenericFunctions.isMobile() && ($el.data("zoom-height-threshold") > $(".zoomWindowContainer div").outerHeight() || $el.data("zoom-width-threshold") > $(".zoomWindowContainer div").outerWidth())) {
                            $('body').addClass("show-zoom");
                        }
                    }
                }
            });
        }
    };
    ProductDetailPage.initGalleryResizeEvents = function () {
        //reinit zoom because the size changes
        $('img.zoomed').removeData('elevateZoom'); //remove zoom instance from image
        $('.zoomWrapper img.zoomed').unwrap();
        $('.zoomContainer').remove();
        $("#zoom-image").elevateZoom({
            gallery: "product-detail-gallery",
            galleryActiveClass: "active",
            responsive: false,
            zoomWindowPosition: 1,
            zoomWindowOffety: -50
        });
        GenericFunctions.isMobile() ? $('body').removeClass("show-zoom") : $('body').addClass("show-zoom");
        //reset
        $("#product-detail-gallery a").removeClass("hiddenRightImage").removeClass("hiddenLeftImage");
        var height = $("#product-detail-gallery").height();
        $("#product-detail-gallery a").each(function () {
            if ($(this).position().top > height) {
                $(this).addClass("hiddenRightImage");
            }
        });
        ProductDetailPage.checkNavigation();
        //show gallery controls
        if ($("#product-detail-gallery a").first().width() * $("#product-detail-gallery a").length > $("#product-detail-gallery").width()) {
            $("#product-detail-gallery .carousel-control-prev").show();
            $("#product-detail-gallery .carousel-control-next").show();
        }
        else {
            $("#product-detail-gallery .carousel-control-prev").hide();
            $("#product-detail-gallery .carousel-control-next").hide();
        }
    };
    ProductDetailPage.showContactForm = function () {
        //set the needed content
        $("#product-form-article-nrs").val($("#product-article-num").text());
        $("#product-form-category").val($("#product-article-category").text());
        var productName = $("#product-brand").text().trim() + " " + $("#product-name span").text().trim() + " " + $("#product-color").text().trim();
        $("#product-form-long-name").val(productName);
        //show content
        $("#product-main-info").hide();
        var $contactInfo = $("#contact-form-product-detail");
        $contactInfo.css("visibility", "hidden");
        $contactInfo.css("opacity", "0");
        $contactInfo.show();
        setTimeout(function () {
            $contactInfo.css("visibility", "visible");
            $contactInfo.css("opacity", "1");
        }, 500);
        //hide techincal data section
        $("#product-technical-data").hide();
        if (GenericFunctions.isMobile()) {
            $("#mobile-pictograms").hide();
            $("#mobile-detail-row").hide();
            $("#eudatasheet-row-mobile").hide();
            $("#product-images").hide();
            $(".row.title-buttons-row").hide();
            ProductDetailPage.loadNavigationButton();
            IframeComms.propagateHeight(true);
        }
    };
    ProductDetailPage.hideContactForm = function () {
        $("#contact-form-product-detail").hide();
        $("#product-main-info").show();
        $("#product-technical-data").show();
        if (GenericFunctions.isMobile()) {
            $("#mobile-pictograms").show();
            $("#mobile-detail-row").show();
            $("#eudatasheet-row-mobile").show();
            $("#product-images").show();
            $(".row.title-buttons-row").show();
            ProductDetailPage.loadNavigationButton();
            IframeComms.propagateHeight(false);
        }
    };
    ProductDetailPage.showFixedMenu = function (topPosition, fromLocalScroll) {
        ProductDetailPage.hideFixedMenu(); //needed for good animations
        var $fixedMenu = $("#fixed-product-header-menu");
        var lastTopPosition = parseInt($fixedMenu.css("top"));
        // This is in order to show the fixed menu below the telering header.
        //if the user is scrolling down
        if (lastTopPosition < topPosition) {
            clearTimeout(ProductDetailPage.timeoutFixedMenuAnimation);
            ProductDetailPage.timeoutFixedMenuAnimation = setTimeout(function () {
                if (fromLocalScroll) {
                    $fixedMenu.css("top", "2px");
                }
                else {
                    //from parent app
                    $fixedMenu.animate({
                        top: (topPosition) + "px",
                    }, 100);
                }
                //common styling
                if ($fixedMenu.css("visibility") != "visible" && !($("#contact-form-product-detail").css("display") == "block")) {
                    $fixedMenu.css("visibility", "hidden");
                    $fixedMenu.css("opacity", "0");
                    $fixedMenu.show();
                    setTimeout(function () {
                        $fixedMenu.css("visibility", "visible");
                        $fixedMenu.css("opacity", "1");
                    }, 500);
                }
            }, 500);
        }
    };
    ProductDetailPage.hideFixedMenu = function () {
        //clear whatever async method to show the dialog
        var $fixedMenu = $("#fixed-product-header-menu");
        $fixedMenu.css("top", "0px");
        clearTimeout(ProductDetailPage.timeoutFixedMenuAnimation);
        if ($fixedMenu.css("visibility") != "hidden") {
            $fixedMenu.css("opacity", "0");
            setTimeout(function () {
                $fixedMenu.css("visibility", "hidden");
                $fixedMenu.hide();
            }, 500);
        }
    };
    ProductDetailPage.toggleFixedMenu = function (scrollPosition, fromLocalScroll) {
        if (fromLocalScroll === void 0) { fromLocalScroll = false; }
        var offsetTop = 0;
        if (GenericFunctions.isVisible("product-detail-gallery")) {
            offsetTop = $("#product-detail-gallery").offset().top;
        }
        else if (GenericFunctions.isVisible("mobile-detail-row")) {
            offsetTop = $("#mobile-detail-row").offset().top;
        }
        if (scrollPosition > offsetTop) {
            ProductDetailPage.showFixedMenu(scrollPosition, fromLocalScroll);
        }
        else {
            ProductDetailPage.hideFixedMenu();
        }
    };
    ProductDetailPage.loadNavigationButton = function () {
        //Navigation buttons
        $("#product-detail-page .navigation-icons .back-button").off("click");
        var appCallback = function () {
            var isContactInfoVisible = GenericFunctions.isVisible("contact-form-product-detail");
            if (isContactInfoVisible && GenericFunctions.isMobile()) {
                $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                    ProductDetailPage.hideContactForm();
                });
            }
            else {
                $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                    History.back();
                });
            }
        };
        var firstNavigationCallback = function () {
            var isContactInfoVisible = GenericFunctions.isVisible("contact-form-product-detail");
            if (isContactInfoVisible && GenericFunctions.isMobile()) {
                $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                    ProductDetailPage.hideContactForm();
                });
            }
            else {
                $("#product-detail-page .navigation-icons .back-button").on("click", function (e) {
                    var url = ProductDetailPage.buildSearchPageUrl();
                    History.pushState({}, url, url);
                });
            }
        };
        GenericFunctions.redirectCallbacks(firstNavigationCallback, appCallback);
    };
    ProductDetailPage.timeoutResize = null;
    ProductDetailPage.timeoutFixedMenuAnimation = null;
    return ProductDetailPage;
}());
exports.ProductDetailPage = ProductDetailPage;
